<template>
<div id="CarAutoForm">  
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  > 
            <v-row>  
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                      v-if="hasCar"
                      v-model="productInfo.chasis"
                      label="*Chasis"
                      :rules="[
                        required('chasis'),
                        //onlyNumeric('syscom_id'),
                      ]"
                  ></v-text-field>                     
                </v-col>        
            </v-row>  
            <v-row
                v-if="hasCar || hasArticle"
              >                
                <v-col cols="4"> 
                  <v-autocomplete
                    v-if="hasCar"
                    v-model="productInfo.brand_id"
                    :hint="`${productInfo.brand_id}`"
                    :items="catbrands"
                    item-text="name"
                    item-value="id"
                    label="Selecciona una Marca"
                    outlined
                  ></v-autocomplete>
                  
                </v-col>               
                <v-col cols="4"> 
                  <v-autocomplete
                    v-if="hasCar"
                    v-model="productInfo.catcarmodel_id"
                    :hint="`${productInfo.catcarmodel_id} - ${catcarmodels.name}`"
                    :items="catcarmodels"
                    item-text="name"
                    item-value="id"
                    label="Seleccione una Modelo"  
                    outlined
                  ></v-autocomplete> 
                </v-col>     
                <v-col cols="4"> 
                   <v-autocomplete
                      v-if="hasCar"
                      v-model="productInfo.catcarversion_id"
                      :hint="`${productInfo.catcarversion_id} - ${productInfo.name}`"
                      :items="catcarversions"
                      item-text="name"
                      item-value="id"
                      label="Selecciona una Version"  
                      outlined
                  ></v-autocomplete>
                </v-col>               
            </v-row>   
            <v-row>  
                <v-col cols="12" sm="6" md="4">
                  <v-combobox
                    v-if="hasCar || hasArticle"
                    v-model="productInfo.transmision" 
                    :items="itemsTransmision"
                    label="Seleccione una Transmision"
                    :rules="[
                      required('tipo de Transmision')
                    ]"       
                  ></v-combobox>                       
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                      v-model="productInfo.year"
                      v-if="hasCar"
                      label="*Año"
                      :rules="[
                        //required('syscom_id'),
                        //onlyNumeric('syscom_id'),
                      ]"
                  ></v-text-field>   
                </v-col>
                <v-col cols="12" sm="6" md="4">   
                  <v-text-field
                      v-model="productInfo.km"
                      v-if="hasCar || hasArticle"
                      label="*Kilometraje"
                      :rules="[
                        //required('syscom_id'),
                        //onlyNumeric('syscom_id'),
                      ]"
                  ></v-text-field>  
                  <!-- v-if="hasCar && productInfo.syscom==0"                       -->                                    
                </v-col>        
            </v-row>                                                               
            <v-row
                v-if="hasQuote || hasPurchase || hasCar || hasPurchaseAll || hasSalesOrder"
             > 
                <v-col cols="12" sm="3" md="3"></v-col>             
                <v-col cols="12" sm="3" md="3">
                  <v-text-field
                    v-model="productInfo.price"                    
                    label="Precio*"
                    value="10.00"
                    prefix="$"
                    :rules="[
                      required('precio'),
                      onlyNumeric('precio'),
                      NoComas('precio')
                    ]"       
                  />                  
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <v-text-field
                      v-model="productInfo.color_ext"
                      v-if="hasCar"
                      label="*Color"                      
                      :rules="[
                        //required('syscom_id'),
                        //onlyNumeric('syscom_id'),
                      ]"
                  ></v-text-field>                                                                    
                </v-col>
                <v-col cols="12" sm="3" md="3"></v-col>             

            </v-row>                                           
            <v-row
                v-if="hasQuote || hasPurchase || hasCar || hasPurchaseAll || hasSalesOrder || hasPrescription"
            >
                <v-col cols="12">
                  <v-textarea
                      v-model="productInfo.notes"                      
                      filled
                      auto-grow
                      label="Escribe comentarios"
                      rows="4"
                      row-height="30"
                      shaped
                  ></v-textarea>  
                </v-col>
            </v-row>      
            <v-row>
              <v-col cols="12" >
                <v-btn
                        v-if="hasReset"
                        color="error"
                        class="mr-4"
                        @click="reset"
                      >
                        <v-icon>cleaning_services</v-icon> Reset Form
                </v-btn> 
                <v-btn
                        color="primary"
                        class="mr-4"
                        @click="submitForm(productInfo)" 
                        :disabled="!valid"                
                >
                      <v-icon>save</v-icon> {{buttonText}}
                </v-btn>                    
              </v-col>
            </v-row>
  </v-form>
</div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import validations from '@/utils/validation';
// import{ DataManager,Query, WebApiAdaptor } from "@syncfusion/ej2-data";
// import baseApi from '@/services/baseApi';
// import icheckApi from '@/services/icheckApi';
// import router from '@/router';

export default {
  name: 'CarAutoForm',  
  components: {
  },  
  computed:{
    // 'products',
    // ...mapState(['priceslist','suppliers','lines','measurements','familycategories','subfamilies'
    // ,'currencies','brands','warehouses','articles']),
    ...mapState(['catbrands','catcarmodels','catcarversions'])

  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading"]),
    async getCatalogo(){ 
      try{        
        this.showLoading({titulo:"Accediendo información",color:"primary"})        
        // console.log("Pricelist "+sword);
        // await this.$store.dispatch('loadBrands',this.attribute); //se carga para component PricelistItem
        // await this.$store.dispatch('loadLines',this.attribute); //se carga para component PricelistItem
        // await this.$store.dispatch('loadMeasurements',this.attribute); //se carga para component PricelistItem
        // await this.$store.dispatch('loadFamilyCategories',this.attribute); //se carga para component PricelistItem
        // await this.$store.dispatch('loadSubFamilies',this.attribute); //se carga para component PricelistItem
        // await this.$store.dispatch('loadWarehouses',this.attribute); //se carga para component Warehouses
      }catch(error){       
        //code 
      }  finally{
        this.hiddenLoading()
      } 
           
    },
    reset () {
        this.$refs.form.reset()
    },
    async getCatBrand(){
          this.attribute.sword='';
          try{        
            this.showLoading({titulo:"Accediendo información",color:"primary"})
            this.$store.dispatch('loadCatBrands',this.attribute);
          }catch(error){
            //console.log(error);
            this.$swal("Error!", "Necesita ingresar sus credenciales", "error");
          } finally{
            this.hiddenLoading()
          }                     
      }, 
       async getCatCarModel(){
          this.attribute.sword='';
          try{        
            this.showLoading({titulo:"Accediendo información",color:"primary"})
            this.$store.dispatch('loadCatCarModels',this.attribute);
          }catch(error){
            //console.log(error);
            this.$swal("Error!", "Necesita ingresar sus credenciales", "error");
          } finally{
            this.hiddenLoading()
          }                     
      }, 
      async getCatCarVersion(){
          this.attribute.sword='';
          try{        
            this.showLoading({titulo:"Accediendo información",color:"primary"})
            this.$store.dispatch('loadCatCarVersions',this.attribute);
          }catch(error){
            //console.log(error);
            this.$swal("Error!", "Necesita ingresar sus credenciales", "error");
          } finally{
            this.hiddenLoading()
          }                     
      },         
    
  },
  props: {
    user: Object,
    product: Object,
    submitForm:String,
    buttonText:String,
    hasValorID:Number,
    hasArticleID:Number,    
    hasCarCreate:String,hasCar:String,
    hasEverybody:String,hasDescription:String,hasReset:String
  },
  data(){
     return{
        valid: false,
        ...validations,
        attribute: {sword: 'All',limit: 27},        
        productInfo:{   
          id:this.product ? this.product.id : "",
          chasis:this.product ? this.product.chasis : "",
          brand_id:this.product ? this.product.brand_id : '',//"139",
          catcarmodel_id:this.product ? this.product.catcarmodel_id : '', //"1",
          catcarversion_id:this.product ? this.product.catcarversion_id : '', // "2",
          transmision:this.product ? this.product.transmision : "automatica",
          year:this.product ? this.product.year : "1",
          km:this.product ? this.product.km : '0',
          price:this.product ? this.product.price : "0",
          color_ext:this.product ? this.product.color_ext : "plata",
          status:this.product ? this.product.status : "Público", 
          notes:this.product ? this.product.notes : "", 
        },
        itemsStatus:[        
          'Público',
          'Privado',
          'Descontinuado',
        ],
        itemsTransmision:[
          // 'KIT',
          'Automatica',
          'Manual',
        ],
     }
  },
  destroyed() {
    console.log("Componente eliminado");
  },
  mounted(){
    console.log("Montado Product Form");
    // if (this.hasValorID>0) {
    //   this.getDataProduct(this.hasValorID)
    // }else if (this.hasArticleID>0) {
    //   // console.log("hasArticleID: "+this.hasArticleID);
    //   this.getDataArticle(this.hasArticleID)
    // }else{
    //   this.getPricelist()
    // }
  },
  created(){
    this.getCatalogo()
    
    // if (this.hasValorID>0) {
    //   this.getPricelist()    
    // }
  }  
}
</script>